import { format } from "date-fns";
import { baseURL } from "../../../../../constants/commonConstants";
import { IEmployeeTrainingDetail } from "../../../../../models/staff/employeeTraining";
import {
  getTrainingBlocks,
  updateTrainingRegisterAndAttend,
} from "../../../../../action/masters/trainingActionCreator";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { connect } from "react-redux";

const TrainingDetails = (props: IEmployeeTrainingDetail) => {
  const {
    setShowEmployeeTraining,
    trainingHelp,
    updateTrainingRegisterAndAttend,
    getTrainingBlocks,
  } = props;

  const handleClose = () => {
    setShowEmployeeTraining(false);
  };

  const isBeforeStartDate = trainingHelp?.trainingDate
    ? new Date() < new Date(trainingHelp.trainingDate)
    : true;

  const trainingRegisterOrAttend = async (id: number, link: string) => {
    const validUrl = /^(http|https):\/\//.test(link) ? link : `https://${link}`;
    window.open(validUrl, "_blank");
    await updateTrainingRegisterAndAttend(id);
    getTrainingBlocks(pageBlockId.trainingBlocks);
  };

  return (
    <>
      <div className="modal-header">
        <h2 className="modal-title fs-5" id="editprofileLabel">
          Trainings Details
        </h2>
        <button
          type="button"
          className="btn-close"
          onClick={handleClose}
        ></button>
      </div>
      <div className="modal-body">
        <div className="row">
          <div className="col-lg-12 label-group img-card">
            <img
              src={
                trainingHelp?.image ? baseURL + trainingHelp.image : undefined
              }
              alt=""
            />
          </div>
          <div className="col-lg-6 label-group">
            <label htmlFor="">Trainings Name</label>
            <p>{trainingHelp?.name}</p>
          </div>
          <div className="col-lg-6 label-group">
            <label htmlFor="">Trainings Category</label>
            <p>{trainingHelp?.trainingCategory}</p>
          </div>
          <div className="col-lg-12 label-group">
            <label htmlFor="">Trainings Describtion</label>
            <p>{trainingHelp?.description}</p>
          </div>
          {trainingHelp?.location && (
            <div className="col-lg-12 label-group">
              <label htmlFor="">Location</label>
              <p>{trainingHelp?.location}</p>
            </div>
          )}
          {trainingHelp?.trainingDate && (
            <div className="col-lg-6 label-group">
              <label htmlFor="">Start Date</label>
              <p>
                {trainingHelp.trainingDate &&
                  format(trainingHelp.trainingDate, "MM-dd-yyyy")}
              </p>
            </div>
          )}
          {trainingHelp?.endDate && (
            <div className="col-lg-6 label-group">
              <label htmlFor="">End Date</label>
              <p>
                {trainingHelp.endDate &&
                  format(trainingHelp.endDate, "MM-dd-yyyy")}
              </p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          {trainingHelp?.isRegistered && trainingHelp?.linkToAttendTraining && (
            <button
              type="button"
              className="btn btn-success btn-training-attend"
              disabled={isBeforeStartDate}
              onClick={() =>
                trainingRegisterOrAttend(
                  trainingHelp.id,
                  trainingHelp.linkToAttendTraining!
                )
              }
            >
              Attend the Training
            </button>
          )}
          {!trainingHelp?.isRegistered && trainingHelp?.linkToRegister && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={() =>
                trainingRegisterOrAttend(
                  trainingHelp.id,
                  trainingHelp.linkToRegister
                )
              }
            >
              Register
            </button>
          )}
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getTrainingBlocks: (pageBlockId?: number, noOfItems?: number) =>
    getTrainingBlocks(pageBlockId, noOfItems),
  updateTrainingRegisterAndAttend: (id: number) =>
    updateTrainingRegisterAndAttend(id),
};

export default connect(null, mapDispatchToProps)(TrainingDetails);
